import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { adsService } from '../services/ads.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';
import type { UpdateCampaignData } from '../types/ads.types';

export function useUpdateCampaign() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ refId, data }: { refId: string; data: UpdateCampaignData }) =>
      adsService.updateCampaign(refId, data),
    onSuccess: (_, { refId }) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', refId] });
      toast.success('Campagne mise à jour avec succès');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}
